<template>
  <div>
    <div v-if="!disabled" class="ml-1 mr-1 p-0 clickable d-flex align-items-center justify-content-center circle"
         :style="{
            'color' : this.getColor().color,
            'background' : this.getColor().background,
            'border-color' : this.getColor().border,
  }">
      <i :class="icon" :style="{ 'margin-left' : this.marginLeft }"></i>
    </div>

    <div v-if="disabled" class="ml-1 mr-1 p-0 disabled d-flex align-items-center justify-content-center circle"
         :style="{
            'color' : this.getColor().color,
            'background' : this.getColor().background,
            'border-color' : this.getColor().border,
            'opacity' : 0.33
    }">
      <i :class="icon" :style="{ 'margin-left' : this.marginLeft }"></i>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Action",
    components:{
    },
    props:{
      icon:{
        default: null,
      },
      mode: {
        default: null,
      },
      marginLeft: {
        default: '0px'
      },
      disabled: {
        default: false,
      }
    },
    data(){
      return {
      }
    },
    mounted (){
    },
    created(){
    },
    methods : {
      getColor() {
        if (this.mode === 'danger') {
          return {
            color: '#DD420A',
            background: '#DD420A1A',
            border: '#DD420A',
          }
        }

        return {
          color: '#000000',
          background: '',
          border: '#707070',
        }
      }
    }
  }
</script>
